<template>
    <div>
<!--      @keydown="searchKey"-->
        <div class="seachBox flex">
            <div class="seachList" style="display: none;"><span class="name">客户名称：</span>
<!--                <a-select-->
<!--                        show-search-->
<!--                        option-filter-prop="children"-->
<!--                        :filter-option="filterOption"-->
<!--                        @change="handleChange"-->
<!--                        placeholder="请选择"-->
<!--                        v-model="seach.a_customer_id" class="seachs" allowClear-->
<!--                >-->
<!--                    <a-select-option :value="item.id" v-for="item in seachList.name">-->
<!--                        {{item.company}}-->
<!--                    </a-select-option>-->
<!--                </a-select>-->

              <a-select
                  placeholder="请输入客户名称"
                  v-model="seach.a_customer_id" class="seachs"
                  :default-active-first-option="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="options"
                  :show-arrow="false"
                  show-search
                  @change="handleChange"
                  @search="handleSearch"
              >
              </a-select>
            </div>
            <div class="seachList"><span class="name">语言：</span>
                <a-select
                        show-search
                        option-filter-prop="children"
                        placeholder="请选择"
                        v-model="seach.a_langset_id" class="seachs" allowClear
                >
                    <a-select-option :value="item.id" :key="item.id" v-for="item in seachList.class">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">翻译日期：</span>
                <a-range-picker class="seachs" v-model="seach.create_time" :allowClear="true" :showTime="false" format="YYYY-MM-DD"/>
            </div>
            <div class="seachList"><span class="name">翻译状态：</span>
                <a-select v-model=" seach.status" class="seachs" allowClear placeholder="请选择" >
                    <a-select-option :value="item.id" :key="item.id" v-for="item in seachList.status">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>

            <div class="seachList"><span class="name">关键词：</span>
                <a-input placeholder="请输入关键字" class="seachs" v-model="seach.name"/>
            </div>
          <div class="seachList"><span class="name">翻译接口：</span>
            <a-select
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                v-model="seach.translation_source" class="seachs" allowClear
            >
              <a-select-option :value="item.id" :key="item.id" v-for="item in seachList.translation_source_list">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList"><span class="name">  </span> </div>
            <div class="seachList  " style="text-align: right">   <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button> </div>

<!--            <div class="seachList no"></div>-->
<!--            <div class="seachList no"></div>-->
        </div>
        <div style="margin-bottom: 12px">
            <a-button class="top_btn" type="primary" :disabled="!hasSelected"
                      @click="submit2()">
                批量翻译
            </a-button>
            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${product_ids.length} 项` }}
        </template>
      </span>
        </div>
      <a-table :columns="columns" :data-source="data" :pagination="pagination" rowKey="id"
               :loading="loadingtable"
               :row-selection="{ selectedRowKeys: product_ids, onChange: onSelectChange,getCheckboxProps:ongetCheckboxProps }"
               v-if="data.length>0">

             <span slot="thumb" slot-scope="text, record">
                 <img :src="record.thumb" alt="" style="width: 100%;display: block">
            </span>
<!--        -->
        <span slot="category" slot-scope="text, record">
                <i v-for="(item,index) in record.category">
                   {{ item }}
                </i>
            </span>
        <span slot="status_name" slot-scope="text, record">
                <p>{{record.status_name}}</p>
                <p>{{record.error_info}}</p>
            </span>

        <span slot="action" slot-scope="text">
                 <a @click="TranslateOpen(text.id)" v-if="text.status==3">继续翻译</a>
<!--                 <a @click="submit2(text.id)" >继续翻译</a>-->
            </span>
      </a-table>
        <a-empty v-else  :description="description" />
<!--      :closable="false"  :maskClosable="false"-->
      <a-modal
          :title="titles"
          :footer="null"
          class="visibleTranslate"
          :width="800"
          @ok="() => (visibleTranslate = false)"
          :visible="visibleTranslate"
          :maskClosable="false"
          :destroyOnClose="true"
          :body-style="{ paddingBottom: '80px' }"
          @cancel="() => {visibleTranslate = false;this.getList(1)}"
      >
        <div v-if="false">
          <a-result  :title="iconTranslate=='loading'?'翻译中...':iconTranslate=='close-circle'?'翻译未完成':'翻译完成'">
            <template #icon>
              <a-icon v-if="iconTranslate=='close-circle'" :type="iconTranslate" style="color: red" />
              <a-icon :type="iconTranslate" v-else />
            </template>
            <template #extra>
              <div style="max-height: 300px;overflow-y: auto">
                <p v-for="(item,index) in langsetTranslate" style="width:600px;text-align: left;margin: 0 auto;border-top: 1px dashed #afafaf;margin-bottom: 15px;padding-top: 15px" class="flex flexs">
                  <a-icon v-if="item.icon=='check-circle'" :type="item.icon"  style="display: inline-block;margin-right: 10px;color:#488adb;position: relative;top:4px; " />
                  <a-icon v-else-if="item.icon=='close-circle'" :type="item.icon"  style="display: inline-block;margin-right: 10px;color:#f00;position: relative;top:4px; " />
                  <a-icon v-else :type="item.icon" style="display: inline-block;margin-right: 10px;position: relative;top:4px; " />
                  <span style="position: relative;top:0px;text-align:left;display: inline-block;width: 450px; word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;">{{item.name[0].name}} </span>

                  <span v-if="item.text=='翻译失败'||item.text=='字符不足'" style="display: inline-block;margin-left: 50px;width: 60px;color: #f00">{{item.text}}</span>
                  <span v-else style="display: inline-block;margin-left: 50px;width: 60px">{{item.text}}</span>
                </p>
              </div>

              <a-button style="margin-top: 50px" v-if="iconTranslate!='loading'" type="primary" @click="()=>{visibleTranslate = false;a_langset_ids=[]; langsetTranslate=[]; getList();iconTranslate='loading' }">
                关闭
              </a-button>
            </template>
          </a-result>
        </div>
        <div v-else>
          <div  class="result" style="font-size: 22px;text-align: center;margin-top: 50px;min-height: 350px">
            <p>翻译任务已提交，</p>
            <p>请稍后前往翻译日志查看</p>
          </div>
        </div>
      </a-modal>
    </div>
</template>

<script>
    import API from "../api";
    import moment from 'moment';
    import {debounce} from "../../../../utils/utils";
    const columns = [
        {
            title: "分类名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name"
        },
        {
            title: "翻译时间",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
        },
        {
            title: "语言",
            dataIndex: "langset_name",
            ellipsis: true,
            key: "langset_name",
        },
        {
            title: "状态",
            dataIndex: "status_name",
            ellipsis: true,
            key: "status_name",
          scopedSlots: {customRender: "status_name"}
        },  {
        title: "翻译接口",
        dataIndex: "translation_source_name",
        ellipsis: true,
        key: "translation_source_name",
      },{
      title: "操作",
          key: "action",
          width: "180px",
          scopedSlots: {customRender: "action"}
    }
    ];
    export default {
        name: "translationLog",
        data() {
            return {
              titles:'',
              loadingtable:true,
              iconTranslate:"loading",
              visibleTranslate:false,
                description:"请先选择客户",
                replaceFields: {children: 'children', title: 'name', key: 'id',value:"id"},
                visibleImg: false,
                tableImg: "",
                seachList: {
                    name: [],
                    class: [],
                  translation_source_list:[]
                },
                seach: {
                    a_customer_id: undefined,
                    // category_id: "",
                    a_langset_id:undefined,
                    name:undefined,
                    status:undefined,
                    create_time:[],
                  translation_source:undefined
                },
              page:1,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showQuickJumper:true
                },
                data: [],
                columns,
                selectedRowKeys: [],
                visible: false,
                title: "",
                product_ids:[] ,
                visibleForm: false,
                titleForm: "",
              a_langset_ids:[],
              langsetTranslate:[],options:[]
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/BatchTranslation/CaseClass"; //设置左侧导航2-2 active
        },
        mounted() {
            // this.getSeachList()
        },
        computed: {
            hasSelected() {
                return this.product_ids.length > 0;
            },

        },
        methods: {
          TranslateOpen(id){
            let self=this
            self.a_langset_ids=id?[id]:self.product_ids
       //      API.service.RETRY_TRANSLATE_CHECK({a_customer_id:self.seach.a_customer_id,record_ids:id?[id]:self.product_ids} ).then(res => {
       // if(res.data.data.translate!=1){
       //   self.$warning({
       //     title: '提示',
       //     content:res.data.msg,
       //   });
       //   self.getList(1)
       // }else{
       //   self.a_langset_ids.map((item,index)=>{
       //     self.langsetTranslate.push({
       //       icon:"loading",
       //       id:item,
       //       name:self.data.filter(items => (items.id==item)) ,
       //       text:"待翻译"
       //     })
       //   })
       //
       //   self.visibleTranslate=true
       //   self.promiseRun(0)
            self.submit2(id)
       // }
       //      })
          },
            getSeachList(company){
                API.service.GET_NAME({company}).then(res => {
                    this.seachList.name = res.data.data
                  res.data.data.forEach((item) => {
                    this.options.push({
                      value: item.id,
                      label: item.company,
                    })
                  });
                })
            },
            handleChange(value) {
                if(value==undefined)return
                this.loadingtable=true
                this.seachList.class=[]
                this.seach.a_langset_id=""
                // API.service.GET_CLASS({a_customer_id:value}).then(res => {
                //     this.seachList.class = res.data.data
                // })
                // this.seach.category_id=""
                this.product_ids=[]
                this.getList()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },

            resetSeach() {
                this.loading = true
                this.seach = {
                    a_customer_id:this.seach.a_customer_id,
                    category_id: undefined,
                    name:undefined,
                    status:undefined,
                    create_time:[]
                }
                this.seachList.class= []
                this.data =[]
                this.getList(1,"reset")
                this.$emit("resetSeach");
            },


          handleSearch: debounce(function (val)   {
            this.handleSearchFn(val)
          }, 300),
          handleSearchFn(val){
            console.log(val)
            this.options=[];
            this.seachList.name=[]
            //下拉模糊查询
            if(val){this.getSeachList(val)}

            // console.log(res);
            // res.data.forEach((item) => {
            //   this.options.push({
            //     value: item.id,
            //     label: item.roomName,
            //   })
            // });
          },
          //
          // handleSearch(val){
          //   console.log(val)
          //   this.options=[];
          //   this.seachList.name=[]
          //   //下拉模糊查询
          //   if(val){this.getSeachList(val)}
          //
          //   // console.log(res);
          //   // res.data.forEach((item) => {
          //   //   this.options.push({
          //   //     value: item.id,
          //   //     label: item.roomName,
          //   //   })
          //   // });
          // },
            getList(page,type) {
              this.loadingtable=true
            this.page=page||this.page
              this.product_ids=[]
                if (this.seach.create_time.length > 0) {
                    this.seach.create_time[0] = moment(this.seach.create_time[0]).format('YYYY-MM-DD')
                    this.seach.create_time[1] = moment(this.seach.create_time[1]).format('YYYY-MM-DD')
                }
                let seachData = JSON.parse(JSON.stringify(this.seach))
                if(this.seach.a_customer_id==undefined){
                    this.data=[]
                    this.description="请先选择客户"
                }
                API.service.PRODUCT_LOG_LIST({page: this.page || 1, ...seachData}).then(res => {
                    if(res.data.code==400 &&type!="reset"){
                        this.$message.destroy()
                        this.$message.error(res.data.msg)
                        return
                    }
                    // this.data = res.data.data.data
                    if(res.data.data.data ){
                        this.data = res.data.data.data}else{ this.data=[]}
                    if( this.data.length>0){
                        this.pagination.total = res.data.data.total
                        this.pagination.pageSize = res.data.data.per_page
                        this.pagination.current = res.data.data.current_page
                    }else{this.description="暂无数据"}
                    this.seachList.status = res.data.data.status
                    this.seachList.class= res.data.data.lang
                  this.seachList.translation_source_list= res.data.data.translation_source_list

                  this.loadingtable=false
                    // console.log("----------111",this.seachList.class)
                })
            },
            onSelectChange(selectedRowKeys) {
                this.product_ids = selectedRowKeys;
            },
          ongetCheckboxProps(record){
            return({
              props: {
                disabled: record.status != 3,
              },
            })
          },
          searchKey(){
            if(event.keyCode == 13){
              this.getList(1)
            }
          },
          // field(){
          //   let i=0
          //   if(this.a_langset_ids.length>0){
          //     this.promiseRun(i)
          //   }
          // },
          promiseRun(i){
            let _that=this
            this.submitField(this.a_langset_ids[i],i).then(res=>{
              if(res!="false"){
                _that.submitField(this.a_langset_ids[res],res).then(resa=>{
                  if(resa!="false"){
                    _that.promiseRun(resa)
                  }else{
                    console.log("***",i)
                    if(i<_that.a_langset_ids.length-1){
                      _that.iconTranslate="close-circle"
                      return
                    }
                    _that.iconTranslate="check-circle"
                  }
                })
              }else{
                console.log("---",i)
                if(i<_that.a_langset_ids.length-1) {
                  _that.iconTranslate="close-circle"
                  return
                }
                  _that.iconTranslate="check-circle"
              }
            })
          },
          submitField(id,i){
            let _that=this
            return new Promise((resolve, reject) => {
              console.log("--**--",i,":::",_that.a_langset_ids.length)
              if(i<_that.a_langset_ids.length){
                _that.langsetTranslate[i].text="翻译中"
                API.service.RETRY_TRANSLATE_PRODUCT({
                  record_ids: id,
                  a_customer_id: _that.seach.a_customer_id
                }).then(res => {
                  if (res.data.code === 1) {
                    _that.langsetTranslate[i].text="翻译成功"
                    _that.langsetTranslate[i].icon="check-circle"
                    i++
                    resolve(i)
                  } else if(res.data.code === 400){
                    _that.langsetTranslate[i].text="翻译失败"
                    _that.langsetTranslate[i].icon="close-circle"
                    i++
                    resolve(i)
                  }
                  else if(res.data.code === 402){
                    _that.langsetTranslate[i].text="字符不足"
                    _that.langsetTranslate[i].icon="close-circle"
                    resolve("false")
                  } else  {
                    // this.$message.destroy()
                    // i++
                    // resolve(i)
                  }
                })
              } else{
                resolve("false")
              }})
          },
          submit2(id) {
            let _that = this
            // _that.a_langset_ids=id?[id]:_that.product_ids
            API.service.RETRY_TRANSLATE_CHECK({
              record_ids: id?[id]:_that.product_ids,
              a_customer_id: _that.seach.a_customer_id
            }).then(res => {
              console.log("res",res)
              console.log("res.data",res.data)
              console.log("res.data.data",res.data.data)
              _that.titles=`批量翻译(剩余字符数${res.data.data.translation_surplus_num})`
              this.visibleTranslate=true
            })
          }
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    /*.visibleTranslate>>>.ant-modal-header{border: unset!important;}*/
    .ant-result{padding-top:0px;padding-bottom:30px}
    .flexs:nth-child(1){border: unset!important;}
</style>
